import { render, staticRenderFns } from "./VaccinationRecordPlaceholder.vue?vue&type=template&id=c6b6d502&"
import script from "./VaccinationRecordPlaceholder.vue?vue&type=script&lang=js&"
export * from "./VaccinationRecordPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports